// extracted by mini-css-extract-plugin
module.exports = {"display":"dispaly-module--display--2Sglh","size_plus":"dispaly-module--size_plus--3MGeW"};